import { IdGenerator } from "src/utils";
import {
  CreateChildPurchaseOrderFormData,
  ChildPOProductInputField,
  PostChildPurchaseOrderRequestBody,
  ChildPOProduct,
  Product,
  PurchaseOrder
} from "src/types";

export class CreateChildPurchaseOrderMapper {
  public static initCreateChildPurchaseOrderFormData(): CreateChildPurchaseOrderFormData {
    return {
      parentPurchaseOrderId: "",
      products: [],
      estDeliveryDate: "",
      operationsNote: ""
    };
  }

  public static productInputFieldFromProducts(products: Product[]): ChildPOProductInputField[] {
    return products.map((product) => {
      const uk = product.ukQuantity ?? product.quantity ?? 0;
      const eu = product.euQuantity ?? 0;
      return {
        fieldId: IdGenerator.generateUniqueElementId(product.id),
        id: product.id,
        sku: product.skuName,
        name: product.name,
        barcode: product.barcode,
        ukQuantity: uk.toString(),
        euQuantity: eu.toString()
      };
    });
  }

  public static initCreateChildPurchaseOrderFormDataFromPurchaseOrder(
    parentPurchaseOrder: PurchaseOrder
  ): CreateChildPurchaseOrderFormData {
    const today = new Date().toISOString().split("T")[0];

    return {
      parentPurchaseOrderId: parentPurchaseOrder.id,
      products: [],
      estDeliveryDate: today,
      operationsNote: ""
    };
  }

  public static createChildPurchaseOrderRequestBodyFromFormData(
    formData: CreateChildPurchaseOrderFormData
  ): PostChildPurchaseOrderRequestBody {
    const normalisedProducts: ChildPOProduct[] = formData.products
      .filter((p) => {
        const uk = parseInt(p.ukQuantity, 10) || 0;
        const eu = parseInt(p.euQuantity, 10) || 0;
        return uk + eu > 0 && p.id && p.id.trim() !== "";
      })
      .map((p) => ({
        id: p.id.trim(),
        ukQuantity: parseInt(p.ukQuantity, 10) || 0,
        euQuantity: parseInt(p.euQuantity, 10) || 0
      }));

    // Convert date to ISOString
    const isoDate = formData.estDeliveryDate
      ? new Date(formData.estDeliveryDate).toISOString()
      : new Date().toISOString();

    const requestBody: PostChildPurchaseOrderRequestBody = {
      products: normalisedProducts,
      estDeliveryDate: isoDate
    };

    // Include operationsNote only if it's provided and not empty
    if (formData.operationsNote && formData.operationsNote.trim()) {
      requestBody.operationsNote = formData.operationsNote.trim();
    }

    return requestBody;
  }
}
